import React, { useContext, useEffect, useState } from "react";
import {
    IntContainer,
    Title,
    StyledSubTitle,
    StyledP,
    Button2,
    StyledGoBack,
    StyledVideoContainer,
    StyledVideo,
} from "./setup.style";
import { ReactComponent as LeftArrow } from "./img/Left_Arrow.svg";
import installGif from "./img/track-conversions.webm";
import FixelDataContext from "../../context/FixelDataContext";
import { useHistory } from "react-router-dom";
import CodeToCopy from "./CodeToCopy";
import useAxios from "../../customHooks/useAxios";

const TrackConversions = () => {
    const sendAxiosRequest = useAxios();
    const history = useHistory();
    const { fullFixelData, setFullFixelData } = useContext(FixelDataContext);
    const [fxl_code, setFxl_code] = useState("");
    const [didTrack, setDidTrack] = useState(false);

    useEffect(() => {
        fullFixelData.code && setFxl_code(fullFixelData.code);
    }, [fullFixelData]);

    const confirmAddSnippet = async (e) => {
        e.preventDefault();
        try {
            await sendAxiosRequest("put", "/fixelData/trackConversions");
            const newFixelData = { ...fullFixelData };
            newFixelData.conversions.enabled = true;
            setFullFixelData(newFixelData);
        } catch (error) {
            console.error(
                "TCL ~ file: TrackConversions.js ~ confirmAddSnippet ~ error",
                error.message || error,
            );
        }

        history.push("/setup");
    };
    return (
        <IntContainer>
            <StyledGoBack onClick={() => history.goBack()}>
                <LeftArrow />
                Go Back
            </StyledGoBack>
            <Title align="left">Track conversions with Fixel</Title>
            <StyledP>
                Add the Fixel snippet to checkout pages for a complete view on your high value visitors.
            </StyledP>
            <StyledSubTitle>Copy the snippet</StyledSubTitle>
            <CodeToCopy fxl_code={fxl_code} />
            <StyledSubTitle>Paste the snippet in the settings page</StyledSubTitle>
            <StyledP>
                Navigate to Setting {">"} Checkout {">"} Order processing (or{" "}
                <a
                    href={`https://${fullFixelData.display}.myshopify.com/admin/settings/checkout`}
                    target="_blank"
                    rel="noreferrer">
                    {" "}
                    click here
                </a>
                ) and paste the snippet in the Additional scripts box{" "}
            </StyledP>
            {/* TODO add fullscreen option with modal */}
            <StyledVideoContainer>
                <StyledVideo controls>
                    <source src={installGif} type="video/webm" />
                    support
                </StyledVideo>
            </StyledVideoContainer>
            <br />
            <form onSubmit={confirmAddSnippet}>
                <input
                    type="checkbox"
                    id="doneSnippet"
                    name="doneSnippet"
                    value="done"
                    checked={didTrack}
                    onChange={() => setDidTrack(!didTrack)}
                />
                <label for="doneSnippet"> I’ve added the snippet to the checkout confirmation page</label>
                <Button2 type="submit" disabled={!didTrack}>
                    Done
                </Button2>
            </form>
        </IntContainer>
    );
};
export default TrackConversions;